import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Unstable_Grid2';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';

const RegistrationDateSelector = ({
  dateObjSetter,
  clearDateTrigger = 0,
  required = false,
  validationState = false,
  testid = '',
  setDate = '',
  setName = '',
  disabled = false,
}) => {
  const defaultDateObject = {
    day: '',
    month: '',
    year: '',
  };
  const [dateObject, setDateObject] = useState(defaultDateObject);

  // setDate hook
  useEffect(() => {
    if (setDate === '') {
      return;
    }
    setDateObject({
      day: setDate ? dayjs(setDate).date() : '',
      month: setDate ? dayjs(setDate).month() + 1 : '',
      year: setDate ? dayjs(setDate).year() : '',
    });
  }, [setDate]);

  // dateObject hook
  useEffect(() => {
    if (
      dateObject.day !== '' &&
      dateObject.month !== '' &&
      dateObject.year != ''
    ) {
      let dateFormatted = '';
      dateFormatted =
        dateObject.year + '-' + dateObject.month + '-' + dateObject.day;
      dateObjSetter(dateFormatted, setName);
    }
  }, [dateObject]);

  // clearDateTrigger Hook
  useEffect(() => {
    if (clearDateTrigger > 0) setDateObject(defaultDateObject);
  }, [clearDateTrigger]);

  const handleFormChange = e => {
    setDateObject(prev => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };

  let daysOfMonth = [];
  for (let x = 1; x <= 31; x++) {
    daysOfMonth.push({ id: x, value: x });
  }
  const monthsOfYear = [
    { id: '1', value: 'January' },
    { id: '2', value: 'February' },
    { id: '3', value: 'March' },
    { id: '4', value: 'April' },
    { id: '5', value: 'May' },
    { id: '6', value: 'June' },
    { id: '7', value: 'July' },
    { id: '8', value: 'August' },
    { id: '9', value: 'September' },
    { id: '10', value: 'October' },
    { id: '11', value: 'November' },
    { id: '12', value: 'December' },
  ];

  const currentYear = new Date().getFullYear();
  let years = [];
  for (let i = currentYear; i >= currentYear - 20; i--) {
    years.push({ id: i, value: i });
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid xs={12} sm={2}>
          <TextField
            fullWidth
            select
            disabled={disabled}
            error={validationState}
            required={required}
            label='Day'
            name='day'
            value={dateObject['day'] ?? ''}
            margin='dense'
            onChange={handleFormChange}
            inputProps={{ 'data-cy': 'date' }}
            id={`date-${testid}`}
          >
            {daysOfMonth.map(day => {
              return (
                <MenuItem key={day.id} value={day.value.toString()}>
                  {day.value}
                </MenuItem>
              );
            })}
          </TextField>
        </Grid>
        <Grid xs={12} sm={4}>
          <TextField
            fullWidth
            select
            disabled={disabled}
            error={validationState}
            required={required}
            label='Month'
            value={dateObject['month'] ?? ''}
            name='month'
            margin='dense'
            onChange={handleFormChange}
            id={`month-${testid}`}
          >
            {monthsOfYear.map(month => {
              return (
                <MenuItem key={month.id} value={month.id}>
                  {month.value}
                </MenuItem>
              );
            })}
          </TextField>
        </Grid>
        <Grid xs={12} sm={6}>
          <TextField
            fullWidth
            disabled={disabled}
            required={required}
            select
            error={validationState}
            label='Year (YYYY)'
            name='year'
            margin='dense'
            value={dateObject['year'] ?? ''}
            onChange={handleFormChange}
            id={`year-${testid}`}
          >
            {years.map(year => {
              return (
                <MenuItem key={year.id} value={year.value.toString()}>
                  {year.value}
                </MenuItem>
              );
            })}
          </TextField>
        </Grid>
      </Grid>
      {validationState && (
        <div className='nanoText errorTxtSpacer errorColor'>
          Please provide a valid date
        </div>
      )}
    </>
  );
};

export default RegistrationDateSelector;
